import {
  ISessionState,
  SessionActionTypes,
  UPDATE_SESSION,
  SET_ONBOARDING_REQUIRED,
  SET_SKIPPED_ONBOARDING,
  AccessLevel,
} from './types'
import { hasAccessToken } from './hasAccessToken'
import { getCurrentAccessLevel } from './credentials'
import { getCurrentUserId } from './credentials'

// Check if token exists to properly initialize isAuthenticated
const tokenExists = (function () {
  try {
    const hasToken = hasAccessToken()
    return hasToken
  } catch (error) {
    console.error(
      'Error checking token existence during initialization:',
      error
    )
    return false
  }
})()

// Get userId only if token exists
const initialUserId = (function () {
  if (!tokenExists) return ''

  try {
    return getCurrentUserId()
  } catch (error) {
    console.error('Error getting user ID during initialization:', error)
    return ''
  }
})()

// Get access level only if token exists
const initialAccessLevel = (function () {
  if (!tokenExists) return AccessLevel.User

  try {
    return getCurrentAccessLevel()
  } catch (error) {
    console.error('Error getting access level during initialization:', error)
    return AccessLevel.User
  }
})()

// Initialization with token-aware values
const initialState: ISessionState = {
  accessLevel: initialAccessLevel,
  isAuthenticated: tokenExists,
  // Ensure sessionInvalidated is ALWAYS false on initial load
  // This prevents the app from showing session-expired when first visiting
  sessionInvalidated: false,
  userId: initialUserId,
  onboardingRequired: true,
  skippedOnboarding: false,
}

// Define reducer function with proper error handling
export function reducer(
  state = initialState,
  action: SessionActionTypes
): ISessionState {
  if (!action) return state

  try {
    switch (action.type) {
      case UPDATE_SESSION:
        return {
          ...state,
          ...action.payload,
        }
      case SET_ONBOARDING_REQUIRED:
        return {
          ...state,
          onboardingRequired: action.payload.onboardingRequired,
        }
      case SET_SKIPPED_ONBOARDING:
        return {
          ...state,
          skippedOnboarding: action.payload.skippedOnboarding,
        }
      default:
        return state
    }
  } catch (error) {
    console.error('Error in session reducer:', error)
    return state
  }
}
